var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibx-404"},[_c('img',{attrs:{"src":"assets/img/404.png","alt":"404-Error"}}),_c('h1',[_vm._v("404 Error Page")]),_c('p',[_vm._v("Oh no! Looks like we can't find the page you are looking for.")])])
}]

export { render, staticRenderFns }